import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule, FormGroup, FormControl, Validators } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { GeneralService } from '../shared/services/general.service';
import { UserService } from '../shared/services/user.service';
import { LoadGeneralComponent } from '../shared/components-generals/load-general/load-general.component';
import { LoginRequest } from '../shared/models/user-model/login-request.model';
import { User } from '../shared/models/user-model/user';
import { InputGeneral } from '../shared/inputs/input-general/input-general';
import { AuthService } from '../shared/services/auth.service';
import { AuthResponse } from '../shared/models/auth-model/auth.model';
import { RecoverPasswordComponent } from './recover-password.component/recover-password.component';
import { MatIcon } from '@angular/material/icon';

@Component({
  selector: 'app-login-aux',
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    MatButtonModule,
    MatDialogModule,
    LoadGeneralComponent,
    InputGeneral,
  ],
  templateUrl: './login.component.html',
})
export class LoginComponent {
  public userId: number = 0;
  public loginattempts: number = 0;

  public userUpdate!: User;
  public isLoading: boolean = false;
  public loginForm: FormGroup = new FormGroup({
    username: new FormControl<string>('', { nonNullable: true, validators: [Validators.required] }),
    password: new FormControl<string>('', { nonNullable: true, validators: [Validators.required] }),
  });
  constructor(
    public dialog: MatDialog,
    public router: Router,
    public authService: AuthService,
    private generalService: GeneralService,
  ) {}

  login() {
    if (this.loginForm.invalid) {
      return;
    }

    // this.isLoading = true;

    const { username, password } = this.loginForm.value as {
      username: string;
      password: string;
    };

    const loginRequest = {
      username: username,
      password: password,
      browserName: this.getBrowserName(),
      isWeb: true,
    };

    this.authService.login(loginRequest).subscribe({
      next: (response) => {
        this.isLoading = false;
        if (response && response.token) {
          localStorage.setItem('token', response.token);
          localStorage.setItem('refreshToken', response.refreshToken);
          localStorage.setItem('userId', `${response.userId}`);
          localStorage.setItem('firstName', response.firstName);
          this.router.navigate(['/home']);
          this.isLoading = false;
        } else {
          this.generalService.viewSnacAlert('Usuario o contraseña incorrectos', 'error', 'Error');
        }
      },
      error: (error) => {
        this.isLoading = false;

        if (error.error === 'IpNotAuthorized') {
          this.generalService.viewSnacAlert(
            'errorMessages.ipNotAuthorized',
            'error',
            'labels.error',
          );
        } else {
          this.generalService.viewSnacAlert('errorMessages.login', 'error', 'labels.error');
        }
      },
    });
  }

  public getControl(formGroup: FormGroup, key: string): FormControl {
    return formGroup.get(key) as FormControl;
  }

  getBrowserName(): string {
    const agent = window.navigator.userAgent.toLowerCase();
    switch (true) {
      case agent.indexOf('edge') > -1:
        return 'edge';
      case agent.indexOf('opr') > -1 && !!(window as any).opr:
        return 'opera';
      case agent.indexOf('chrome') > -1 && !!(window as any).chrome:
        return 'chrome';
      case agent.indexOf('trident') > -1:
        return 'ie';
      case agent.indexOf('firefox') > -1:
        return 'firefox';
      case agent.indexOf('safari') > -1:
        return 'safari';
      default:
        return 'other';
    }
  }

  openRecoverPasswordDialog(): void {
    const dialogRef = this.dialog.open(RecoverPasswordComponent, {
      width: '25vw',
      maxWidth: '25vw',
      maxHeight: '40vh',
      autoFocus: false,
    });
    dialogRef.afterClosed().subscribe(async (result) => {
      if (result) {
      }
    });
  }
}
